<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "county-code",
  
})
</script>
<template>
    <div :class="['contry-pop coutry', { active: visible }]">+ {{ visibleCode }}</div>
</template>
<script setup lang="ts" name="county-code">
import { COUNTRY_PHONE_CONFIG } from '@/enums'

const emits = defineEmits(['countryCodeChange'])

const actions = COUNTRY_PHONE_CONFIG[0]
const visibleCode = ref(actions.code)

const visible = ref(false)

onMounted(() => {
    emits('countryCodeChange', visibleCode.value)
})
</script>
<style scoped lang="scss">
.coutry {
    @apply flex justify-center items-center gap-[10px];
    position: relative;
    width: 100%;
    height: 100%;

    .code-icon {
        width: 120px;
        text-align: center;
        text-indent: 30px;
    }
    &.active {
        &::after {
            transform: rotateX(180deg);
        }
    }

    .code-list {
        position: absolute;
        top: 110px;
        min-height: 200px;
        max-height: 300px;
        overflow: auto;
        width: 100%;
        background: #fff;
        font-family: MicrosoftYaHei-Bold;
        z-index: 10;

        .code-item {
            line-height: 50px;
            font-size: 26px;
            font-weight: bold;
            color: #000;
            text-align: center;
            border-bottom: 2px solid rgba(255, 255, 255, 1);

            &:active {
                background-color: #ccc;
            }
        }
    }
    .coutry-input {
        width: 100%;
        height: 100%;
        padding-right: 30px;
        background-color: rgba(0, 0, 0, 0);
    }
}
</style>
